module.exports = __webpack_public_path__ + "media/app/assets/specializations/warrior/protection-222b0fdce4d61ee8e5a175cd02b7a45f.png";